module.exports = __webpack_public_path__ + "static/media/green-s-35.de3d12b8.png";